export const notificationService = {
  async requestPermission() {
    console.log("[NotificationService] Solicitando permissão...");
    if (!("Notification" in window)) {
      console.warn("[NotificationService] Este navegador não suporta notificações desktop.");
      return false;
    }

    if (Notification.permission === "granted") {
      console.log("[NotificationService] Permissão já concedida.");
      return true;
    }

    if (Notification.permission !== "denied") {
      const permission = await Notification.requestPermission();
      console.log("[NotificationService] Resposta da permissão:", permission);
      return permission === "granted";
    }

    console.warn("[NotificationService] Permissão negada pelo usuário.");
    return false;
  },

  showBrowserNotification(title, body, icon = "/img/icons/icon.png", onClick = null) {
    console.log("[NotificationService] Tentando exibir notificação:", { title, body });
    if (Notification.permission === "granted") {
      try {
        const options = {
          body,
          icon,
          badge: "/img/icons/icon.png",
        };
        const n = new Notification(title, options);
        n.onclick = () => {
          console.log("[NotificationService] Notificação clicada.");
          window.focus();
          if (onClick && typeof onClick === "function") {
            onClick();
          }
        };
      } catch (error) {
        console.error("[NotificationService] Erro ao exibir notificação:", error);
      }
    } else {
      console.warn("[NotificationService] Permissão não concedida para exibir notificação:", Notification.permission);
    }
  },
};
